import { Controller } from "@hotwired/stimulus"

// A native <dialog>: showModal() gives the top layer, backdrop, focus trap and
// Escape for free, so this only opens it and closes it from the backdrop.
export default class extends Controller {
  open() {
    if (!this.element.open) this.element.showModal()
  }

  close() {
    this.element.close()
  }

  // The panel inside the dialog stops its own clicks, so a click that reaches
  // the dialog element itself landed on the backdrop.
  closeOnBackdrop(event) {
    if (event.target === this.element) this.close()
  }
}
